import { Component } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'notchmark-bulk-error-modal',
  imports: [ButtonModule,CommonModule],
    standalone: true,

  templateUrl: './bulk-error-modal.component.html',
  styleUrl: './bulk-error-modal.component.scss'
})
export class BulkErrorModalComponent {
  assetsConst = assets;
   errorCount = 0;
  errorList: string[] = [];
 constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,

  ) {
   const errorListData = this.config.data?.errorList;
    if (errorListData && Array.isArray(errorListData) && errorListData.length > 0) {
      const firstElement = errorListData[0];
       this.errorList = firstElement;
      if (firstElement && typeof firstElement === 'object' && firstElement.errors) {
        this.errorList = Array.isArray(firstElement.errors) ? firstElement.errors : [firstElement.errors];
      } 
      else if (typeof firstElement === 'string') {
        this.errorList = errorListData;
      }
    }
    this.errorCount = this.errorList.length || this.config.data?.errorCount || 0;

    
  }
  
  uploadAgain() {
    this.ref.close(true);
  }
  closeDialog() {
    this.ref.close(false);
  }
}
